/* let accessToken = null;
let refreshToken = null;
let guId = null; */

// Setters and Getters for Access Token
export function setAccessToken(aToken) {
  sessionStorage.setItem("accessToken", aToken);
}
export function getAccessToken() {
  return sessionStorage.getItem("accessToken");
}
export function clearAccessToken() {
  sessionStorage.setItem("accessToken", null);
}

// Setters and Getters for Refresh Token
export function setRefreshToken(rToken) {
  sessionStorage.setItem("refreshToken", rToken);
  sessionStorage.setItem("refreshtoken", rToken);
}
export function getRefreshToken() {
  return sessionStorage.getItem("refreshToken") || sessionStorage.getItem("refreshtoken");
}
export function clearRefreshToken() {
  sessionStorage.setItem("refreshToken", null);
  sessionStorage.setItem("refreshtoken", null);
}

// Setters and Getters for guId
export function setGuId(guid) {
  sessionStorage.setItem("guid", guid);
  sessionStorage.setItem("guId", guid);
}
export function getGuId() {
  return sessionStorage.getItem("guid") || sessionStorage.getItem("guId");
}
export function clearGuId() {
  sessionStorage.setItem("guid", null);
  sessionStorage.setItem("guId", null);
}

// Setters and Getters for loginid
export function setLoginId(loginId) {
  sessionStorage.setItem("loginid", loginId);
  sessionStorage.setItem("id", loginId);
}
export function getLoginId() {
  return sessionStorage.getItem("loginid") || sessionStorage.getItem("id");
}
export function clearLoginId() {
  sessionStorage.setItem("loginid", null);
  sessionStorage.setItem("id", null);
}

// Setters and Getters for First Name
export function setFirstname(firstname) {
  sessionStorage.setItem("firstname", firstname);
}
export function getFirstname() {
  return sessionStorage.getItem("firstname");
}
export function clearFirstname() {
  sessionStorage.setItem("firstname", null);
}

// Setters and Getters for Last Name
export function setLastname(lastname) {
  sessionStorage.setItem("lastname", lastname);
}
export function getLastname() {
  return sessionStorage.getItem("lastname");
}
export function clearLastname() {
  sessionStorage.setItem("lastname", null);
}
// Setters and Getters for Email
export function setEmailID(email) {
  sessionStorage.setItem("email", email);
}
export function getEmailID() {
  return sessionStorage.getItem("email");
}
export function clearEmailID() {
  sessionStorage.setItem("email", null);
}

// Setters and Getters for MakeInvitations
export function setMakeInvitations(makeInvitations) {
  sessionStorage.setItem("MakeInvitations", String(makeInvitations));
}
export function getMakeInvitations() {
  return sessionStorage.getItem("MakeInvitations");
}
export function clearMakeInvitations() {
  sessionStorage.setItem("MakeInvitations", null);
}

// Setters and Getters for Language
export function setLanguage(language) {
  sessionStorage.setItem("language", language);
}
export function getLanguage() {
  return sessionStorage.getItem("language");
}
export function clearLanguage() {
  sessionStorage.setItem("language", null);
}

const SIDEBAR_COLLAPSED_KEY = "sidebarCollapsed";
const SSO_LOGIN_KEY = "isSSOLogin";

export function setSidebarCollapsed(isCollapsed) {
  sessionStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(Boolean(isCollapsed)));
}

export function getSidebarCollapsed() {
  return sessionStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
}

export function clearSidebarCollapsed() {
  sessionStorage.removeItem(SIDEBAR_COLLAPSED_KEY);
}

// Setters and Getters for SSO login state
export function setSSOLogin(isSSOLogin) {
  sessionStorage.setItem(SSO_LOGIN_KEY, String(Number(Boolean(isSSOLogin))));
}

export function getSSOLogin() {
  return sessionStorage.getItem(SSO_LOGIN_KEY) === "1";
}

export function clearSSOLogin() {
  sessionStorage.setItem(SSO_LOGIN_KEY, null);
}
